interface IUserAvatarProps {
    url: string
    styleClass: string
}

export function openPassport() {
    window.open(`https://passport.yandex.ru/auth?origin=drivelongterm&retpath=${window.location.href}`, "_self");
}

export default function UserAvatar(props: IUserAvatarProps) {
    let img = props.url.length === 0 ? "https://avatars.mds.yandex.net/get-yapic/0/0-0" : props.url
    return <button
        className={props.styleClass} style={{backgroundImage: `url(${img})`, backgroundSize: 'cover'}}
        onClick={() => openPassport()}
    />
}